import { render, staticRenderFns } from "./BtnIncluirApoio.vue?vue&type=template&id=45061bbc"
import script from "./BtnIncluirApoio.vue?vue&type=script&lang=js"
export * from "./BtnIncluirApoio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports